import { render, staticRenderFns } from "./TifProveedoresForm.vue?vue&type=template&id=3f8f0da0"
import script from "./TifProveedoresForm.vue?vue&type=script&lang=js"
export * from "./TifProveedoresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports